export interface Location {
  id: string;
  name: string;
  shortName: string;
  address: string;
  city: string;
  state: string;
  postcode: string;
  phone: string;
  email: string;
  googleMapsUrl: string;
  googleMapsEmbed: string;
  gmbProfileUrl: string;
  coordinates: {
    lat: number;
    lng: number;
  };
  hours: {
    weekdays: string;
    saturday: string;
    sunday: string;
  };
  directions: string[];
  services: string[];
}

export const locations: Location[] = [
  {
    id: "virginia",
    name: "Virginia, QLD",
    shortName: "Virginia",
    address: "Unit 3/7 Lathe St",
    city: "Virginia",
    state: "QLD",
    postcode: "4014",
    phone: "0457 585 901",
    email: "admin@supremeturf.com.au",
    googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=Unit+3%2F7+Lathe+St%2C+Virginia+QLD+4014",
    googleMapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3543.5!2d153.0788!3d-27.4253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjfCsDI1JzMxLjEiUyAxNTPCsDA0JzQzLjciRQ!5e0!3m2!1sen!2sau!4v1",
    gmbProfileUrl: "https://share.google/kyxBCZS16pmm4f01H",
    coordinates: { lat: -27.4253, lng: 153.0788 },
    hours: {
      weekdays: "7:00 AM - 5:00 PM",
      saturday: "8:00 AM - 12:00 PM",
      sunday: "Closed"
    },
    directions: [
      "From Brisbane CBD, take the Gateway Motorway North",
      "Exit at Nudgee Road and head east towards Virginia",
      "Turn left onto Lathe Street, our warehouse is Unit 3/7 on the right"
    ],
    services: [
      "Full product range available",
      "Trade pickup available",
      "Sample viewing room",
      "On-site consultation available"
    ]
  },
  {
    id: "darra",
    name: "Darra, QLD",
    shortName: "Darra",
    address: "6 Fienta Pl",
    city: "Darra",
    state: "QLD",
    postcode: "4076",
    phone: "0450 954 913",
    email: "admin@supremeturf.com.au",
    googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=6+Fienta+Pl%2C+Darra+QLD+4076",
    googleMapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3538.8!2d152.9541!3d-27.5514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjfCsDMzJzA1LjAiUyAxNTLCsDU3JzE0LjgiRQ!5e0!3m2!1sen!2sau!4v1",
    gmbProfileUrl: "https://share.google/P8GmtRV9fqqF55Uxf",
    coordinates: { lat: -27.5514, lng: 152.9541 },
    hours: {
      weekdays: "7:00 AM - 5:00 PM",
      saturday: "8:00 AM - 12:00 PM",
      sunday: "Closed"
    },
    directions: [
      "From Brisbane CBD, take the Ipswich Motorway west",
      "Exit at the Oxley Road interchange",
      "Head south on Fienta Place, our warehouse is number 6"
    ],
    services: [
      "Full product range available",
      "Large format sample display",
      "Forklift loading for bulk orders",
      "Same-day pickup for in-stock items"
    ]
  },
  {
    id: "mount-druitt",
    name: "Mount Druitt, NSW",
    shortName: "Mount Druitt",
    address: "Unit 11/8 Wainwright Rd",
    city: "Mount Druitt",
    state: "NSW",
    postcode: "2770",
    phone: "0472 708 699",
    email: "sydney@supremeturf.com.au",
    googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=Unit+11%2F8+Wainwright+Rd%2C+Mount+Druitt+NSW+2770",
    googleMapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3314.9!2d150.8185!3d-33.7702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDQ2JzEyLjciUyAxNTDCsDQ5JzA2LjYiRQ!5e0!3m2!1sen!2sau!4v1",
    gmbProfileUrl: "https://share.google/PcgwWmqAvltfRW9H4",
    coordinates: { lat: -33.7702, lng: 150.8185 },
    hours: {
      weekdays: "7:00 AM - 5:00 PM",
      saturday: "8:00 AM - 12:00 PM",
      sunday: "Closed"
    },
    directions: [
      "From Sydney CBD, take the M4 Western Motorway",
      "Exit at Mount Druitt and head north on Carlisle Avenue",
      "Turn onto Wainwright Road, Unit 11/8 is in the industrial estate"
    ],
    services: [
      "Full product range available",
      "Sydney metro delivery hub",
      "Trade account pickup",
      "Product demonstrations available"
    ]
  },
  {
    id: "ridleyton",
    name: "Ridleyton, SA",
    shortName: "Ridleyton",
    address: "153 South Road",
    city: "Ridleyton",
    state: "SA",
    postcode: "5008",
    phone: "0482 025 766",
    email: "adelaide@supremeturf.com.au",
    googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=153+South+Road%2C+Ridleyton+SA+5008",
    googleMapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3271.5!2d138.5745!3d-34.8987!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDUzJzU1LjMiUyAxMzjCsDM0JzI4LjIiRQ!5e0!3m2!1sen!2sau!4v1",
    gmbProfileUrl: "https://share.google/gaoFkDW0x7p9Centv",
    coordinates: { lat: -34.8987, lng: 138.5745 },
    hours: {
      weekdays: "8:00 AM - 5:00 PM",
      saturday: "9:00 AM - 4:00 PM",
      sunday: "Closed"
    },
    directions: [
      "From Adelaide CBD, head north on West Terrace",
      "Continue onto South Road heading north",
      "Our showroom is at 153 South Road on the left side"
    ],
    services: [
      "Full product range available",
      "Adelaide metro delivery hub",
      "Showroom with product displays",
      "Expert consultation services"
    ]
  },
  {
    id: "truganina",
    name: "Truganina, VIC",
    shortName: "Truganina",
    address: "39A Apex Drive",
    city: "Truganina",
    state: "VIC",
    postcode: "3029",
    phone: "0405 720 400",
    email: "melbourne@supremeturf.com.au",
    googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=39A+Apex+Drive%2C+Truganina+VIC+3029",
    googleMapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3152.8!2d144.7523!3d-37.8279!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDQ5JzQwLjQiUyAxNDTCsDQ1JzA4LjMiRQ!5e0!3m2!1sen!2sau!4v1",
    gmbProfileUrl: "https://share.google/yLCraPwKAm11mkyfK",
    coordinates: { lat: -37.8279, lng: 144.7523 },
    hours: {
      weekdays: "7:00 AM - 5:00 PM",
      saturday: "8:00 AM - 12:00 PM",
      sunday: "Closed"
    },
    directions: [
      "From Melbourne CBD, take the Western Ring Road (M80)",
      "Exit at Derrimut Road and head south",
      "Turn onto Apex Drive, our warehouse is at 39A"
    ],
    services: [
      "Full product range available",
      "Melbourne metro delivery hub",
      "Bulk order processing",
      "Trade account services"
    ]
  }
];

export const getLocationById = (id: string): Location | undefined => {
  return locations.find(loc => loc.id === id);
};

export const getFullAddress = (location: Location): string => {
  return `${location.address}, ${location.city}, ${location.state} ${location.postcode}`;
};
